import { Draggable } from '../gsap/setup';

export function initStickers() {
  const $draggable = $('.js-draggable');

  $draggable.each((i, el) => {
    const $container = $(el);
    const $stickers = $container.find('*[data-draggable]');

    if ($stickers.length) {
      Draggable.create($stickers, {
        type: 'x,y',
        edgeResistance: 0.8,
        bounds: $container[0],
        zIndexBoost: false,
      });
    }
  });
}
